const DEFAULT_BASE_FONT_SIZE = 16;
const getBodyFontSize = (useDefaultBaseFontSize = false) => {
    if (!document || !document.body || useDefaultBaseFontSize) {
        return DEFAULT_BASE_FONT_SIZE;
    }
    const { fontSize } = getComputedStyle(document.body);
    return fontSize.includes('rem') ? DEFAULT_BASE_FONT_SIZE : parseFloat(fontSize);
};
export const pxToRem = (pixels, useDefaultBaseFontSize = true) => {
    if (typeof pixels !== 'number')
        throw new Error('Pixels argument is not a number');
    return pixels / getBodyFontSize(useDefaultBaseFontSize);
};
export const remToPx = (rems) => {
    if (typeof rems !== 'number')
        throw new Error('Rems argument is not a number');
    return rems * getBodyFontSize();
};
//# sourceMappingURL=pxAndRemConversion.js.map